import { createRoute, dynamicWrapper } from '@/utils/core'
import intl from 'react-intl-universal';

const routesConfig = app => ({
    path: '/screen/index',
    title: intl.get('/datav/display1'),
    component: dynamicWrapper(app, [
        import('./model/index'),
        import('./model/config'),
        import('./model/device'),
    ], () =>
        import('./components/index')
    )
})

export default app => createRoute(app, routesConfig)
